import type { FilterItem } from '@/features/fanfiction-filters/types/fanfiction-filters.types';

export const getVisibleFilterItems = (
  items: FilterItem[],
  searchQuery: string,
  isShowMore: boolean,
  listLimit: number,
): FilterItem[] => {
  const normalizedQuery = searchQuery.trim().toLowerCase();
  if (normalizedQuery) {
    return items.filter((item) => item.name.toLowerCase().includes(normalizedQuery));
  }

  return isShowMore ? items : items.slice(0, listLimit);
};

export const buildSelectedCharacterLabels = (
  updatedIds: string[],
  labelSource: Record<string, string>,
  characters: FilterItem[],
): Record<string, string> =>
  Object.fromEntries(
    updatedIds
      .map((selectedId) => {
        const label =
          labelSource[selectedId] ||
          characters.find((entry) => entry.id === selectedId)?.name ||
          '';
        return [selectedId, label] as const;
      })
      .filter(([, label]) => label.length > 0),
  );

export const getFilterItemId = (item: FilterItem): string => (item.id as string) || item.name;
